<template>
  <div id="energyDetailPage">
    <nav class="screenDateBox">
      <div class="pathDisplay">
        <span class="pathCls">电量</span>
        <i class="iconfont icon-fanhui2 pointCls"></i>
        <span class="pathCls curEnergyName">{{ energyTitle }}</span>
      </div>
      <el-image
        class="screenDateItem"
        v-for="(img, index) in screenDateImgs"
        :key="index"
        :src="img.url"
        @click="screenDatetapAction(index)"
      ></el-image>
    </nav>
    <div id="contentBox">
      <div class="gridPart" v-show="isShowItem">
        <div
          class="chartCls"
          v-for="(item, index) in dataSource.gridPart"
          :key="index"
        >
          <linePointChartComponent
            :curDateType="screenDateImgs[curSelectedIndex].dateValue"
            :dataSource="item"
            :energyType="curEnergyType"
          ></linePointChartComponent>
        </div>
      </div>
      <div class="sectionPart" v-show="isShowSection">
        <div
          class="sectionItem"
          v-for="(sectionItem, index) in dataSource.sectionPart"
          :key="index"
        >
          <div class="sectionTitle">
            <span class="signCls"></span>
            {{ sectionItem.name }}
          </div>
          <div class="sectionContent">
            <div
              class="chartBox"
              v-for="(item, itemIndex) in sectionItem.equipments"
              :key="itemIndex"
            >
              <linePointChartComponent
                :curDateType="screenDateImgs[curSelectedIndex].dateValue"
                :dataSource="item"
                :energyType="curEnergyType"
              ></linePointChartComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateType, energySystemType, energyDataType } from "@/utils/typeParam";
import linePointChartComponent from "@/components/subComponents/linePointChartComponent";
import requestObjc from "@/utils/requestObjc";
import mainStore from "@/store/storeMain";
import { mapGetters } from "vuex";

export default {
  name: "energyDetailPage",
  store: mainStore,
  components: {
    linePointChartComponent,
  },
  data() {
    return {
      curEnergyType: energyDataType.electricity,
      curSelectedIndex: 2,
      screenDateImgs: [
        {
          url: require("@/assets/month.png"),
          imgUrl: require("@/assets/month.png"),
          imgSelUrl: require("@/assets/month_blue.png"),
          dateValue: dateType.monthType,
        },
        {
          url: require("@/assets/day.png"),
          imgUrl: require("@/assets/day.png"),
          imgSelUrl: require("@/assets/day_blue.png"),
          dateValue: dateType.dayType,
        },
        {
          url: require("@/assets/hour_blue.png"),
          imgUrl: require("@/assets/hour.png"),
          imgSelUrl: require("@/assets/hour_blue.png"),
          dateValue: dateType.hourType,
        },
      ],
      energyType: this.$route.query.energyType,
      energyTitle: this.$route.query.energyTitle,
      isShowItem: false, //显示分格部分
      isShowSection: false, //显示分区部分
      dataSource: {
        gridPart: [], //分格部分数据源
        sectionPart: [], //分区部分数据源
      },
      curGateway: "", //当前网关
    };
  },
  computed: {
    ...mapGetters({
      curHouseInfo: "getCurHouseInfo",
    }),
  },
  created() {
    //初始化网关数据
    this.curGateway = this.curHouseInfo.gatewayId;
    this.requestDataAction(1);
  },
  methods: {
    //请求数据
    requestDataAction(dateType) {
      //根据能耗类型请求不同的数据
      switch (this.energyType) {
        case energySystemType.airElectricity:
          this.requestAirData(dateType);
          break;
        case energySystemType.freshAirElectricity:
          this.requestFreshAirData(dateType);
          break;
        case energySystemType.purificationWaterElectricity:
          this.requestPurificationWaterData(dateType);
          break;
        case energySystemType.lampElectricity:
          this.requestLampData(dateType);
          break;
        case energySystemType.hotWaterElectricity:
          this.requestHotWaterData(dateType);
          break;
        case energySystemType.socketElectricity:
          this.requestSocketData(dateType);
          break;
        default:
          break;
      }
    },
    //时间选择点击方法
    screenDatetapAction(tapIndex) {
      if (this.curSelectedIndex == tapIndex) {
        return;
      }
      this.screenDateImgs[this.curSelectedIndex].url = this.screenDateImgs[
        this.curSelectedIndex
      ].imgUrl;
      this.screenDateImgs[tapIndex].url = this.screenDateImgs[
        tapIndex
      ].imgSelUrl;
      this.curSelectedIndex = tapIndex;
      //重新请求数据
      this.$set(this.dataSource, "gridPart", []);
      this.$set(this.dataSource, "sectionPart", []);
      this.requestDataAction(this.screenDateImgs[tapIndex].dateValue);
    },
    //按时间排序
    dataSort(arr) {
      var array = arr;
      array.sort((a, b) => {
        if (a.key < b.key) {
          return -1;
        }
        return 1;
      });
      return array;
    },
    //空调数据
    requestAirData(dateType) {
      //空调数据既显示分格部分也显示分区部分
      this.$set(this, "isShowItem", true);
      this.$set(this, "isShowSection", true);
      var params = {
        datatimetype: dateType,
      };
      requestObjc
        .requestAirElectricity(params, this.curGateway)
        .then((res) => {
          var data = JSON.parse(JSON.stringify(res.data));
          //解析分格部分数据
          var airHost = {
            title: "空调主机",
            dataArr: [],
            timeArr: [],
          };
          var fanCoil = {
            title: "所有风机",
            dataArr: [],
            timeArr: [],
          };
          var airHostDataArr = this.dataSort(data.airHost.data);
          var fanCoilDataArr = this.dataSort(data.fanCoil.data);
          airHostDataArr.forEach((item) => {
            airHost.timeArr.push(item.key);
            airHost.dataArr.push(item.data1);
          });
          fanCoilDataArr.forEach((item) => {
            fanCoil.timeArr.push(item.key);
            fanCoil.dataArr.push(item.data1);
          });
          this.dataSource.gridPart.push(airHost);
          this.dataSource.gridPart.push(fanCoil);
          //解析分区部分数据
          this.sectionPartAnalysis(res.data);
        })
        .catch((error) => {
          console.log("请求空调电量数据失败：" + error.message);
        });
    },
    //新风数据
    requestFreshAirData(dateType) {
      //只显示分格部分，不显示分区部分
      this.$set(this, "isShowItem", true);
      this.$set(this, "isShowSection", false);
      var params = {
        datatimetype: dateType,
      };
      requestObjc
        .requestFreshAirElectricity(params, this.curGateway)
        .then((res) => {
          var data = JSON.parse(JSON.stringify(res.data));
          data.forEach((roomItem) => {
            roomItem.equipments.forEach((equipmentItem) => {
              var equipment = {
                title: roomItem.name + "·" + equipmentItem.name,
                timeArr: [],
                dataArr: [],
              };
              var dataList = this.dataSort(equipmentItem.data.data);
              dataList.forEach((item) => {
                equipment.timeArr.push(item.key);
                equipment.dataArr.push(item.data1);
              });
              this.dataSource.gridPart.push(equipment);
            });
          });
        })
        .catch((error) => {
          console.log("请求新风电量数据失败：" + error.message);
        });
    },
    //净水数据
    requestPurificationWaterData(dateType) {
      //只显示分格部分，不显示分区部分
      this.$set(this, "isShowItem", true);
      this.$set(this, "isShowSection", false);
      var params = {
        datatimetype: dateType,
      };
      requestObjc
        .requestPurificationWaterElectricity(params, this.curGateway)
        .then((res) => {
          this.gridPartAnalysisWithRoom(res);
        })
        .catch((error) => {
          console.log("请求净水电量数据失败：" + error.message);
        });
    },
    //灯光数据
    requestLampData(dateType) {
      //不显示分格部分，只显示分区部分
      this.$set(this, "isShowItem", false);
      this.$set(this, "isShowSection", true);
      var params = {
        datatimetype: dateType,
      };
      requestObjc
        .requestLampElectricity(params, this.curGateway)
        .then((res) => {
          var data = {
            floors: res.data,
          };
          this.sectionPartAnalysis(data);
        })
        .catch((error) => {
          console.log("请求灯光电量数据失败：" + error.message);
        });
    },
    //热水数据
    requestHotWaterData(dateType) {
      //只显示分格部分，不显示分区部分
      this.$set(this, "isShowItem", true);
      this.$set(this, "isShowSection", false);
      var params = {
        datatimetype: dateType,
      };
      requestObjc
        .requestHotWater(params, this.curGateway)
        .then((res) => {
          this.gridPartAnalysisWithRoom(res);
        })
        .catch((error) => {
          console.log("请求热水电量数据失败：" + error.message);
        });
    },
    //插座数据
    requestSocketData(dateType) {
      //不显示分格部分，只显示分区部分
      this.$set(this, "isShowItem", false);
      this.$set(this, "isShowSection", true);
      var params = {
        datatimetype: dateType,
      };
      requestObjc
        .requestSocketElectricity(params, this.curGateway)
        .then((res) => {
          var data = {
            floors: res.data,
          };
          this.sectionPartAnalysis(data);
        })
        .catch((error) => {
          console.log("请求插座电量数据失败：" + error.message);
        });
    },
    //按房间的分格结构数据解析
    gridPartAnalysisWithRoom(dataValue) {
      var data = JSON.parse(JSON.stringify(dataValue.data));
      data.forEach((equipmentItem) => {
        var equipment = {
          title: equipmentItem.name,
          timeArr: [],
          dataArr: [],
        };
        var dataList = this.dataSort(equipmentItem.data.data);
        dataList.forEach((item) => {
          equipment.timeArr.push(item.key);
          equipment.dataArr.push(item.data1);
        });
        this.dataSource.gridPart.push(equipment);
      });
    },
    //分区结构数据解析
    sectionPartAnalysis(dataValue) {
      var data = JSON.parse(JSON.stringify(dataValue));
      data.floors.forEach((floorItem) => {
        var floorData = {
          name: floorItem.name,
          equipments: [],
        };
        floorItem.rooms.forEach((roomItem) => {
          if (roomItem.equipments.length == 0) {
            var equipment = {
              title: roomItem.name,
              timeArr: [],
              dataArr: [],
            };
            floorData.equipments.push(equipment);
          } else {
            roomItem.equipments.forEach((equipmentItem) => {
              var equipment = {
                title: roomItem.name + "·" + equipmentItem.name,
                timeArr: [],
                dataArr: [],
              };
              var dataList = this.dataSort(equipmentItem.data.data);
              dataList.forEach((dataItem) => {
                equipment.timeArr.push(dataItem.key);
                equipment.dataArr.push(dataItem.data1);
              });
              floorData.equipments.push(equipment);
            });
          }
        });
        this.dataSource.sectionPart.push(floorData);
      });
    },
  },
};
</script>
<style scoped>
#energyDetailPage {
  width: 85%;
  margin: 0 auto;
}
.screenDateBox {
  width: 100%;
  height: 50px;
  margin-top: 30px;
  text-align: left;
}
.screenDateItem {
  width: 37px;
  height: 37px;
  float: right;
  margin-left: 29px;
}
.screenDateItem:hover {
  cursor: pointer;
}
.pathDisplay {
  height: 100%;
  display: inline-block;
}
.pathCls {
  font-size: 22px;
}
.pointCls {
  font-size: 18px;
  margin-left: 10px;
}
.curEnergyName {
  color: #2592fa;
  margin-left: 10px;
}
/* 分格部分 */
.contentBox {
  width: 100%;
}
.gridPart,
.sectionContent {
  margin: 0px 0px 20px 0px;
  padding: 0px;
  width: 100%;
  display: grid;
  justify-content: space-around;
  grid-template-columns: 600px 600px;
}
.chartCls {
  height: 260px;
  overflow: hidden;
  box-shadow: 0px 8px 18px 0px rgba(206, 231, 255, 0.21);
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  padding-top: 20px;
}
/* 分区部分 */
.sectionPart {
  width: 100%;
  margin-bottom: 20px;
}
.sectionItem {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 8px 18px 0px rgba(206, 231, 255, 0.21);
  overflow: hidden;
  border-radius: 10px;
  margin-top: 20px;
}
.sectionTitle {
  height: 50px;
  font-size: 26px;
  padding-left: 20px;
  display: flex;
  align-items: center;
}
.signCls {
  width: 12px;
  height: 12px;
  background-color: #f07878;
  border-radius: 50%;
  margin-right: 20px;
}
.chartBox {
  height: 260px;
  margin-top: 20px;
  padding-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/detailPages/energyDetail.vue